import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/legacy.css";
import "./styles/app.css";
import "./styles/op-waiting.css";
import "./styles/mobile.css";
// Тема — последней: при равной специфичности её правила перекрывают базовые.
// Какой файл стоит за "@theme", решает VITE_THEME при сборке (vite.config.ts).
import "@theme";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
